@if (showFooter()) {
  <div class="tw-h-36"></div>
  <div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-[11] tw-bg-orange-60 tw-drop-shadow-[2px_-2px_7px_rgba(0,0,0,0.2)]">
    <div class="tw-relative tw-flex tw-items-center tw-gap-fluid-20 tw-pl-fluid-20 tw-pr-fluid-16">
      @if (processed().regimenCoverImage) {
        <div class="tw-shrink-0 tw--mt-3 tw-h-20 tw-w-20 tw-rounded-[7px] tw-bg-orange-60 tw-p-1.5">
          <div class="tw-h-full tw-w-full tw-overflow-hidden tw-rounded-[4px] tw-bg-orange-100">
            <img class="tw-h-full tw-w-full tw-object-cover" [src]="processed().regimenCoverImage" alt="treatment kit" />
          </div>
        </div>
      }
      <div class="tw-min-w-0">
        <p class="tw-font-lexend tw-font-medium tw-text-300 tw-text-gray-900" i18n="@@yourTreatmentPlan">Your Treatment Plan</p>
        <p class="tw-font-lexend tw-font-bold tw-text-200 tw-uppercase tw-tracking-[2.31px] tw-text-orange-150">{{ concern() }}</p>
      </div>
    </div>

    <div class="tw-px-4 tw-pb-6 tw-pt-4">
      <button class="tw-relative tw-h-12 tw-w-full tw-overflow-visible tw-rounded-3 tw-border-none tw-bg-teal-600 tw-pl-[66px] tw-pr-4 tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.1)] shine loop"
              (click)="buyRegimen()">
        <div class="tw-absolute tw-left-2 tw-top-1/2 tw--translate-y-1/2 tw-flex tw-items-center tw-justify-center tw-text-orange-400">
          <svg class="tw-relative tw-h-16 tw-w-16 tw-animate-spin_slow" xmlns="http://www.w3.org/2000/svg" width="64.443" height="67.447" viewBox="0 0 64.443 67.447">
            <path d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                  transform="translate(-23.961 -186.363)" fill="#D66736"></path>
          </svg>
          <span class="tw-absolute tw-z-20 tw-font-body tw-text-500 tw-font-bold tw-leading-none tw-text-white">
            <span>{{ processed().discount }}%</span><br />
            <span class="tw-font-medium" i18n="@@off">Off</span>
          </span>
        </div>
        <span class="tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20.8px] tw-text-white">
          <span i18n="@@buyNow">Buy Now</span>
          <span> &#64;</span>
          <span class="tw-font-normal tw-text-200 tw-line-through">₹{{ processed().totalMRP }}</span>
          <span> ₹{{ processed().totalSP }}</span>
        </span>
      </button>
    </div>
  </div>
}
